<div class="container">
    <div *ngFor="let location of locations;  let last = last;">
        <div class="content">
            <div class="location-icon">
                <svg-icon class="icon" src='/assets/icons/location.svg'></svg-icon>
            </div>
    
            <div class="location-items">
                <ng-container *ngIf="location">
                    <span class="locaion-item">{{location}}{{last ? '' : ', '}} </span>
                </ng-container>
            </div>
        </div>
    </div>
</div>

